import { useEffect, useState } from 'react';
import styles from './MySubscription.module.css';
import useAuthStore from '../../store/authStore';
import { ENDPOINTS } from '../../utils/endpoints';
import api from '../../services/api';
import CircularProgress from '@mui/material/CircularProgress';

const MyMembership = () => {
    const { user } = useAuthStore();
    const [membershipData, setMembershipData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMembershipData = async () => {
            try {
                const { data } = await api.post(ENDPOINTS.GET_USER_MEMBERSHIP, { user_id: user?.id });
                if (data.success) {
                    setMembershipData(data);
                }
            } catch (err) {
                console.error('Error fetching membership data:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchMembershipData();
    }, [user?.id]);

    // if (loading) return <div className={styles.container}><div className={styles.loader}>Loading...</div></div>;
    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <CircularProgress style={{ color: 'white' }} />
            </div>
        );
    }

    if (!membershipData) return <div className={styles.container}><div className={styles.empty}>No membership data found.</div></div>;

    return (
        membershipData &&
        <div className={styles.container}>
            <h2 className={styles.title}>My Membership</h2>

            {membershipData.memberships.map((membership, index) => (
                <div className={styles.membershipCard} key={index}>
                    <h3 className={styles.membershipHeader}>{membership.membership?.label}</h3>

                    <div className={styles.infoGrid}>
                        <div><span className={styles.label}>Description:</span></div>
                        <div className={styles.value}>{membership.membership?.short_description}</div>

                        <div><span className={styles.label}>Status:</span></div>
                        <div className={styles.value}>{membership.status_text}</div>

                        <div><span className={styles.label}>Valid From:</span></div>
                        <div className={styles.value}>{membership.start_time}</div>

                        <div><span className={styles.label}>Expires On:</span></div>
                        <div className={styles.value}>{membership.expire_time}</div>

                        <div><span className={styles.label}>Days Remaining:</span></div>
                        <div className={styles.value}>{membership.days_remaining}</div>

                        <div><span className={styles.label}>Price:</span></div>
                        <div className={styles.value}>{membership.billing_info?.price_display}</div>
                    </div>

                    <div className={styles.detailsBox}>
                        <h4>Payment Summary</h4>
                        <table className={styles.summaryTable}>
                            <tbody>
                                <tr>
                                    <td>Total Paid</td>
                                    <td>${membership.payment_info.payment_summary?.total_amount}</td>
                                </tr>
                                <tr>
                                    <td>Completed Orders</td>
                                    <td>{membership.payment_info.payment_summary?.completed_orders}</td>
                                </tr>
                                <tr>
                                    <td>Pending Orders</td>
                                    <td>{membership.payment_info.payment_summary?.pending_orders}</td>
                                </tr>
                                <tr>
                                    <td>Failed Orders</td>
                                    <td>{membership.payment_info.payment_summary?.failed_orders}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={styles.detailsBox}>
                        <h4>Order History</h4>
                        <table className={styles.orderTable}>
                            <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {membership.payment_info.all_orders.map((order, idx) => (
                                    <tr key={idx}>
                                        <td>{order.order_id}</td>
                                        <td>{order.created_date}</td>
                                        <td>{order.status}</td>
                                        <td>${order.amount} {order.currency}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    );

};

export default MyMembership;
